export const spritesConfig = [
  // scene1
  // {
  //   's1-coffee': {
  //     anchor: {
  //       x: 0.5,
  //       y: 0.5
  //     },
  //     position: {
  //       x: 694,
  //       y: 486
  //     }
  //   },
  //   's1-loading': {
  //     anchor: {
  //       x: 0.5,
  //       y: 0.5
  //     },
  //     position: {
  //       x: 694,
  //       y: 282
  //     }
  //   },
  //   's1-title': {
  //     anchor: {
  //       x: 0.5,
  //       y: 0.5
  //     },
  //     position: {
  //       x: 694,
  //       y: 154
  //     }
  //   }
  // },
  // scene2
  {
    's2-leaf': {
      position: {
        x: 1258,
        y: 0
      }
    },
    's2-calendar': {
      position: {
        x: 0,
        y: 20
      }
    },
    's2-computer': {
      position: {
        x: 240,
        y: 0
      }
    },
    's2-coffee': {
      position: {
        x: 98,
        y: 258
      }
    },
    's2-keyboard': {
      anchor: {
        x: 0,
        y: 1
      },
      position: {
        x: 390,
        y: 750
      }
    },
    's2-notes': {
      position: {
        x: 900,
        y: 220
      }
    },
    's2-rabbits': {
      anchor: {
        x: 0,
        y: 1
      },
      position: {
        x: 866,
        y: 204
      }
    },
    's2-dialog': {
      position: {
        x: 1120,
        y: 120
      }
    },
    's2-arrows': {
      anchor: {
        x: 0.5,
        y: 0.5
      },
      position: {
        x: 676,
        y: 610
      }
    }
  },
  // scene 3
  {
    's3-person': {
      anchor: {
        x: 0,
        y: 1
      },
      position: {
        x: 1708,
        y: 750
      }
    },
    's3-hand': {
      position: {
        x: 1476,
        y: 272
      }
    },
    's3-sound': {
      position: {
        x: 1886,
        y: 102
      }
    },
    's3-rabbit1': {
      anchor: {
        x: 0,
        y: 1
      },
      position: {
        x: 1822,
        y: 750
      }
    },
    's3-rabbit2': {
      anchor: {
        x: 0,
        y: 1
      },
      position: {
        x: 1822,
        y: 750
      }
    },
    's3-rabbit3': {
      anchor: {
        x: 0,
        y: 1
      },
      position: {
        x: 1822,
        y: 750
      }
    },
    's3-mouth1': {
      position: {
        x: 2191,
        y: 332
      }
    },
    's3-mouth2': {
      position: {
        x: 2196,
        y: 348
      }
    },
    's3-mouth3': {
      position: {
        x: 2196,
        y: 352
      }
    },
    's3-mouth4': {
      position: {
        x: 2208,
        y: 335
      }
    },
    's3-dialog1': {
      position: {
        x: 2628,
        y: 158
      }
    },
    's3-dialog2': {
      position: {
        x: 3067,
        y: 526
      }
    },
    's3-dialog3': {
      position: {
        x: 3274,
        y: 186
      }
    },
    's3-dialog4': {
      position: {
        x: 3740,
        y: 402
      }
    },
    's3-breeze1': {
      position: {
        x: 3334,
        y: 80
      }
    },
    's3-breeze2': {
      position: {
        x: 3308,
        y: 430
      }
    },
    's3-leaf1': {
      position: {
        x: 3762,
        y: 38
      }
    }
  },
  {
    's4-pop': {
      position: {
        x: 5280,
        y: 0
      }
    },
    's4-hour': {
      anchor: {
        x: 0.5,
        y: 1
      },
      position: {
        x: 5157,
        y: 155
      }
    },
    's4-min': {
      position: {
        x: 5159,
        y: 155
      }
    },
    's4-dialog': {
      position: {
        x: 4987,
        y: 128
      }
    }
  },
  {
    's5-rabbit': {
      position: {
        x: 5976,
        y: 50
      }
    },
    's5-dialog': {
      position: {
        x: 6050,
        y: 276
      }
    },
    's5-left-hand1': {
      anchor: {
        x: 1,
        y: 0
      },
      position: {
        x: 6144,
        y: 544
      }
    },
    's5-left-hand2': {
      anchor: {
        x: 1,
        y: 0
      },
      position: {
        x: 6144,
        y: 544
      }
    },
    's5-right-hand': {
      anchor: {
        x: 1,
        y: 0
      },
      position: {
        x: 6300,
        y: 662
      }
    },
    's5-para': {
      position: {
        x: 6633,
        y: 134
      }
    }
  },
  {
    's6-dialog1': {
      position: {
        x: 8072,
        y: 198
      }
    },
    's6-dialog2': {
      position: {
        x: 8116,
        y: 312
      }
    },
    's6-dialog3': {
      position: {
        x: 8270,
        y: 64
      }
    },
    's6-dialog4': {
      position: {
        x: 8005,
        y: 407
      }
    },
    's6-bulb': {
      position: {
        x: 8550,
        y: 45
      }
    }
  },
  {
    's7-q1': {
      position: {
        x: 8692,
        y: 28
      }
    },
    's7-q2': {
      anchor: {
        x: 0,
        y: 1
      },
      position: {
        x: 9260,
        y: 160
      }
    },
    's7-q3': {
      position: {
        x: 9344,
        y: 166
      }
    },
    's7-q4': {
      anchor: {
        x: 1,
        y: 0
      },
      position: {
        x: 9536,
        y: 0
      }
    },
    's7-dialog': {
      position: {
        x: 9234,
        y: 212
      }
    },
  },
  {
    's8-qa1': {
      position: {
        x: 10300,
        y: 22
      }
    },
    's8-qa2': {
      position: {
        x: 10274,
        y: 158
      }
    },
    's8-qa3': {
      position: {
        x: 10834,
        y: 32
      }
    },
    's8-qb1': {
      position: {
        x: 10902,
        y: 115
      }
    },
    's8-qb2': {
      position: {
        x: 11404,
        y: 200
      }
    },
    's8-qb3': {
      position: {
        x: 11366,
        y: 72
      }
    },
  },
  {
    's9-dialog1': {
      anchor: {
        x: 0,
        y: 1
      },
      position: {
        x: 12172,
        y: 226
      }
    },
    's9-dialog3': {
      position: {
        x: 12082,
        y: 358
      }
    },
    's9-dialog2': {
      anchor: {
        x: 1,
        y: 0
      },
      position: {
        x: 12304,
        y: 497
      }
    }
  },
  {
    's10-pot': {
      position: {
        x: 13661,
        y: 20
      }
    },
    's10-person': {
      anchor: {
        x: 0,
        y: 1
      },
      position: {
        x: 14140,
        y: 750
      }
    },
    's10-dialog': {
      position: {
        x: 14224,
        y: 38
      }
    }
  },
  {
    's11-hour': {
      anchor: {
        x: 0.5,
        y: 1
      },
      position: {
        x: 15214,
        y: 108
      }
    },
    's11-min': {
      position: {
        x: 15212,
        y: 104
      }
    },
    // 's11-txt1': {
    //   anchor: {
    //     x: 0.5,
    //     y: 0.5
    //   },
    //   position: {
    //     x: 15203,
    //     y: 202
    //   }
    // },
    // 's11-txt2': {
    //   anchor: {
    //     x: 0.5,
    //     y: 0.5
    //   },
    //   position: {
    //     x: 15203,
    //     y: 272
    //   }
    // },
    // 's11-txt3': {
    //   position: {
    //     x: 14754,
    //     y: 463
    //   }
    // },
    // 's11-txt4': {
    //   position: {
    //     x: 15242,
    //     y: 478
    //   }
    // },
    // 's11-txt5': {
    //   position: {
    //     x: 15238,
    //     y: 548
    //   }
    // },
    // 's11-txt6': {
    //   position: {
    //     x: 15518,
    //     y: 540
    //   }
    // },
    's11-txt7': {
      anchor: {
        x: 0.5,
        y: 0.5
      },
      position: {
        x: 15203,
        y: 392
      }
    },
  },
  {
    's12-dialog': {
      position: {
        x: 16185,
        y: 90
      }
    }
  },
  {
    's13-face1': {
      anchor: {
        x: 0,
        y: 1
      },
      position: {
        x: 18188,
        y: 420
      }
    },
    's13-face2': {
      anchor: {
        x: 0,
        y: 1
      },
      position: {
        x: 18188,
        y: 418
      }
    },
    's13-face3': {
      anchor: {
        x: 0,
        y: 1
      },
      position: {
        x: 18188,
        y: 420
      }
    },
    's13-txt1': {
      position: {
        x: 17766,
        y: 504
      }
    },
    // 's13-slogan': {
    //   position: {
    //     x: 18600,
    //     y: 62
    //   }
    // },
    // 's13-qr': {
    //   position: {
    //     x: 18260,
    //     y: 580
    //   }
    // }
  }
]
